import type { Model } from '@libs/data-access/entities'
import { schema } from 'normalizr'
import type { PayPeriod as PayPeriodSchema } from 'snap-redux/infra/http/routesConfig/scopes/planning/types'

export type PayPeriodModel = Model<PayPeriodSchema>

const PayPeriod = new schema.Entity<PayPeriodModel>('payPeriods', {})

export default PayPeriod
